import { Box, Typography, CircularProgress, Button, Container, Backdrop, Snackbar, Dialog, Stack } from "@mui/material";
import CompteInfoForm from "../components/forms/CompteInfoForm";
import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";
import { useState, useContext } from "react";
import { Context } from "../App";

export default function Compte() {
    const { setIsConnected } = useContext(Context);
    const [loading, setLoad] = useState(false)
    const [msg, setMsg] = useState('');

    const [open, setOpen] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [action, setAction] = useState('');

    function manageSnackbar(open, msg = '') {
        setOpen(open);
        setMsg(msg);
    }

    function manageDialog(open, action="") {
        setDialogOpen(open);
        setAction(action);
    }

    async function handleSubmit(e) {
        e.preventDefault();
        setLoad(true);
        setMsg('');

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/user/mail/reset-password`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify({ _id: localStorage.getItem('user')})
            });
            const token = response.headers.get('x-auth-token');
            if (token) localStorage.setItem('token', token);
            if (response.status === 401) {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                setIsConnected(false);
                throw new Error('Unauthorized');
            }

            let message = '';

            if (!response.ok) {
                const errorText = await response.text();
                message = errorText || 'Erreur lors de l\'envoi de l\'e-mail.';
            } else {
                message = 'Un e-mail de réinitialisation a été envoyé à votre adresse.';
            }
            manageSnackbar(true, message);
        } catch (error) {
            console.error('Erreur lors de la réinitialisation du mot de passe :', error);
            manageSnackbar(true, 'Une erreur est survenue. Veuillez réessayer plus tard.');
        } finally {
            setLoad(false);
            manageDialog(false);
        }
    }

    return (
    <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        <Header />
        <Box sx={{ display:'flex', flexDirection: 'column', flexGrow: 1, px: { xs: 1, sm: 3 } }}>
            <Typography variant="h2" component="h1" m={5}>Mon compte</Typography>
            <CompteInfoForm />

            <Button variant="text" color="focus2" sx={{alignSelf:'center', textDecoration:'underline', mt:2}} onClick={() => manageDialog(true, 'password')}>Modifier mon mot de passe</Button>

            <Dialog open={dialogOpen} onClose={() => manageDialog(false)} maxWidth="xs" fullWidth>
                {action === 'password' &&
                    <Box component='form' onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', p: 3 }}>
                        <Typography variant="h4" align="center" color="focus2" sx={{ mb: 2 }}>Modification du mot de passe</Typography>
                        <Typography variant="body1" sx={{ mb: 1, fontSize: 14, fontWeight: 600, fontStyle: 'italic', textAlign: 'center' }}>
                            Un mail de réinitialisation de mot de passe, contenant un lien valable 24h vous sera envoyé.
                        </Typography>

                        <Stack spacing={1} direction='row' alignItems='center' alignSelf={'center'} mt={3}>
                            <Button variant="text" color="black" onClick={() => manageDialog(false)} sx={{ alignSelf: 'center' }}>Annuler</Button>
                            <Button type="submit" variant="contained" color="focus2" sx={{ alignSelf: 'center', color:"white", px: 5 }}>Envoyer le lien</Button>
                        </Stack>
                    </Box>
                }
            </Dialog>

            <Backdrop open={loading}><CircularProgress/></Backdrop>

            <Snackbar open={open} autoHideDuration={5000} onClose={() => manageSnackbar(false)} message={msg}/>
        </Box>
        <Footer />
    </Box>
    )
}